import { TextAreaEditor, TextAreaEditorElement } from '@approvalmax/ui';
import { forwardRef, memo, useCallback } from 'react';

import { TextAreaEditorWrapperProps } from './TextAreaEditorWrapper.types';

const TextAreaEditorWrapper = memo(
    forwardRef<TextAreaEditorElement, TextAreaEditorWrapperProps>((props, ref) => {
        const { invalid, value, onLineFieldUpdate, lineItemId, placeholder } = props;

        const onChange = useCallback(
            (value: string) => {
                onLineFieldUpdate(lineItemId, 'description', value);
            },
            [lineItemId, onLineFieldUpdate]
        );

        return (
            <TextAreaEditor
                ref={ref}
                invalid={invalid}
                value={value || ''}
                onChange={onChange}
                placeholder={placeholder}
                theme='transparent'
                changeOnBlur
                maxLength={4000}
                size='fixed'
                height={1}
                rowHeight={20}
                title={value}
            />
        );
    })
);

export default TextAreaEditorWrapper;
